import React from "react";
import classes from "./artistCard.module.css";
import { ARTIST_NEXT_DOOR_DEFAULT_IMAGE } from "../../../utils/images";

const ArtistCard = ({ artist, onVote, onViewPerformance }) => {
  return (
    <div className={classes.artistCard}>
      <div className={classes.imageContainer}>
        <img
          src={
            artist?.participant?.displayPictureUrl !== undefined
              ? artist?.participant?.displayPictureUrl
              : ARTIST_NEXT_DOOR_DEFAULT_IMAGE
          }
          alt={artist?.participant?.username}
        />
        <div className={classes.voteCount}>
          <span>{artist?.contestInfo?.votes}</span> votes
        </div>
      </div>

      <div className={classes.artistInfo}>
        <h3>{artist?.participant?.username}</h3>

        <div className={classes.cardActions}>
          <button className={classes.voteButton} onClick={onVote}>
            Cast Vote
          </button>

          <button className={classes.viewButton} onClick={onViewPerformance}>
            View Performance
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtistCard;
